export const VideoAgreementScreens = {
  INTRODUCTION: 'INTRODUCTION',
  INSTRUCTIONS: 'INSTRUCTIONS',
  VIDEO_AGREEMENT: 'VIDEO_AGREEMENT',
  VALIDATION: 'VALIDATION',
};
